let apiErrorHandler = null;

export const initApiErrorService = (showErrorFn) => {
  apiErrorHandler = showErrorFn;
};

export const showGlobalApiError = (error, options = {}) => {
  if (apiErrorHandler) {
    apiErrorHandler(error, options);
  }
};

export const isApiErrorServiceInitialized = () => {
  return apiErrorHandler !== null;
};